export class ApiError extends Error {
  constructor(readonly status: number, readonly code: string, message: string) {
    super(message);
    this.name = 'ApiError';
  }
}

export class ApiClient {
  csrfToken: string | null = null;

  async request<Value>(path: string, options: { method?: string; body?: unknown } = {}): Promise<Value> {
    const method = options.method ?? 'GET';
    const headers = new Headers({ Accept: 'application/json' });
    if (method !== 'GET') {
      headers.set('Content-Type', 'application/json');
      if (this.csrfToken) headers.set('X-CSRF-Token', this.csrfToken);
    }
    const response = await fetch(path, {
      method,
      headers,
      credentials: 'same-origin',
      ...(options.body === undefined ? {} : { body: JSON.stringify(options.body) }),
    });
    if (response.status === 204) return undefined as Value;
    const value = await response.json() as Value & { error?: { code?: string; message?: string } };
    if (!response.ok) {
      throw new ApiError(
        response.status,
        value.error?.code ?? 'request_failed',
        value.error?.message ?? 'The request failed.',
      );
    }
    return value;
  }
}
